export function withOpacity(color, opacity) {
  if (color === void 0) {
    color = '#000000';
  }
  if (opacity === void 0) {
    opacity = 1;
  }
  var opacityHex = Math.round(opacity * 255).toString(16).padStart(2, '0');
  return color + opacityHex;
}